import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const CreatePasswordInput = () => {
  const rules = {
    minLength: {
      value: 8,
      message: 'Password must be at least 8 characters long'
    }
  };
  return (
    <VpHookFormInput
      maxLength={50}
      rules={rules}
      required
      name="password"
      type="password"
      placeholder="Password"
    />
  );
};

export default CreatePasswordInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/CreatePasswordInput.jsx